import { IdentityResourcesService } from "@/services/api-service";
import lodash from "lodash";

const state = {
  count: 0,
  pages: 1,
  list: [],
  current: {},
  original: {},
  originalJSON: ""
};

const getters = {
  count: state => state.count,
  pages: state => state.pages,
  list: state => state.list,
  current: state => state.current,

  isDirty: state => {
    const currentJSON = JSON.stringify(state.current);
    return currentJSON !== state.originalJSON;
  }
};

const actions = {
  async fetchList(context, params) {
    if (params.offset === 0) context.commit("reset");
    const { data } = await IdentityResourcesService.query(params);
    context.commit("set", {
      result: data,
      limit: params.limit
    });
  },

  async fetch(context, id) {
    const { data } = await IdentityResourcesService.get(id);
    context.commit("setCurrent", data.identityResource);
  },
  async add(context, resource) {
    await IdentityResourcesService.add(resource);
    await context.dispatch("fetchList", { limit: 20, offset: 0 });
  },
  async save(context) {
    const { data } = await IdentityResourcesService.save(state.current);
    context.commit("setCurrent", data.identityResource);
  },
  async delete(context) {
    await IdentityResourcesService.destroy(state.current.id);
    context.commit("remove", state.current);
  },
  async addClaims(context, claim) {
    context.commit("addClaim", claim);
    await context.dispatch("save");
  },
  async removeClaims(context, claim) {
    context.commit("removeClaim", claim);
    await context.dispatch("save");
  }
};

const mutations = {
  set(state, data) {
    state.list.push(...data.result.identityResources);
    state.count = data.result.identityResourcesCount;
    state.pages =
      Math.ceil(state.count / data.limit) == 0
        ? 1
        : Math.ceil(state.count / data.limit);
  },
  reset(state) {
    state.list = [];
    state.count = 0;
    state.pages = 1;
  },
  setCurrent(state, entity) {
    state.original = entity;
    state.current = entity;
    state.originalJSON = JSON.stringify(state.original);
  },
  remove(state, entity) {
    state.list.splice(state.list.indexOf(entity), 1);
    state.current = {};
  },
  addClaim(state, claim) {
    claim.forEach(r => {
      state.current.allowedClaims.push(r.type);
    });
  },
  removeClaim(state, claim) {
    claim.forEach(r => {
      lodash.remove(state.current.allowedClaims, item => item === r);
    });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
